import { render } from "./SegmentedController.vue?vue&type=template&id=27ae00be&scoped=true&ts=true"
import script from "./SegmentedController.vue?vue&type=script&lang=ts"
export * from "./SegmentedController.vue?vue&type=script&lang=ts"

import "./SegmentedController.vue?vue&type=style&index=0&id=27ae00be&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ae00be"]])

export default __exports__